import { Chip, Grid, TextField } from '@material-ui/core'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getStationsParent, getUnitsConfigs, setUnitsInputs } from 'redux/actions/unitsSection/unitsAction';
import { Autocomplete } from '@material-ui/lab'
import RegularButton from 'components/CustomButtons/Button'
import CloseIcon from "@material-ui/icons/Close";
import { useSearch } from 'hooks/useSearch'

export const UnitsInputs = ({tableKey}) => {
  const dispatch = useDispatch()
  const {
    company,
    station,
  } = useSelector(({unitsReducer}) => unitsReducer)
  const { companiesList } = useSelector(({companies}) => companies)
  const {isLoadingComp} = useSelector(({search}) => search)
  const {restoreTable, setSnackbar} = useSearch()
  const handleUnitsInputs = (v, key) => {
    const value = v ? v : null
    dispatch( setUnitsInputs(value, key) )
  }
  
  const handleSubmit = () => {
    if(!station) return setSnackbar('Selecciona una planta')
    restoreTable(tableKey.units)
    restoreTable(tableKey.tags)
    dispatch(getUnitsConfigs(station?.id))
    dispatch(getStationsParent(station?.id))
  }
  return (
    <form
      onSubmit={handleSubmit}
      style={{
        width: "100%",
        padding: 4,
      }}
    >
      <Grid container spacing={1} style={{
        alignItems: "center",
      }}>
        <Grid item xs={12} sm={4} >
          <Autocomplete
            id="companies-combo-units"
            options={companiesList}
            value={company}
            getOptionLabel={(option) => option?.label || ""}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  variant="outlined"
                  label={option.label}
                  {...getTagProps({ index })}
                  style={{
                    borderRadius: 4,
                  }}
                />
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Razón Social"
                variant="outlined"
                size="small"
              />
            )}
            fullWidth
            onChange={(e, v) => handleUnitsInputs(v, 'company')}
            noOptionsText="No se encuentra la planta"
            closeIcon={ <CloseIcon fontSize="small"/> }
          />
        </Grid>
        <Grid item xs={12} sm={4} >
          <Autocomplete
            id="stations-combo-units"
            options={company?.stations || []}
            value={station}
            getOptionLabel={(option) => option?.label || ""}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  variant="outlined"
                  label={option.label}
                  {...getTagProps({ index })}
                  style={{
                    borderRadius: 4,
                  }}
                />
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Planta"
                variant="outlined"
                size="small"
              />
            )}
            fullWidth
            onChange={(e, v) => handleUnitsInputs(v, 'station')}
            noOptionsText="No se encuentra la planta"
            closeIcon={ <CloseIcon fontSize="small"/> }
          />
        </Grid>

        <Grid
          item
          xs={12}
          sm={1}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <RegularButton color="info" onClick={handleSubmit} fullWidth disabled={ !station?.id } loading={isLoadingComp?.loadingUnits}>
            buscar
          </RegularButton>
        </Grid>
      </Grid>
    </form>
  )
}
